
import DefaultEntityConsult from 'components/form/DefaultEntityConsult'
import Produto from 'entity/Produto'
import Rodada from 'entity/Rodada'

import React from 'react'

export default function ProdutoConsulta() {



    return (
        <DefaultEntityConsult
            initialFilters={{ status: "ATIVO" }}
            EntityClass={Produto}
            titulo={"Produtos"}
            routeForm={'produto'}

        // updatedValues={Reuniao.updatedValues}
        />
    )
}

// import React, { useCallback, useEffect, useState } from 'react'
// import { useNavigate } from 'react-router-dom';

// import { useAppContext } from 'app/AppContext';
// import DataTable from 'components/DataTable';
// import { fetchArray } from 'entity';
// import Produto from 'entity/Produto';

// import { Box, CircularProgress, Typography } from '@mui/material';
// import TextField from '@mui/material/TextField';
// import Accordion from '@mui/material/Accordion';
// import AccordionSummary from '@mui/material/AccordionSummary';
// import AccordionDetails from '@mui/material/AccordionDetails';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// export default function ProdutoForm() {
//     const navigate = useNavigate();
//     const { useSetTitle, setActionsView } = useAppContext();
//     const [options, setOptions] = useState([]);
//     const [searchNomeProduto, setSearchNomeProduto] = useState("");
//     const [filteredOptions, setFilteredOptions] = useState([]);
//     const [searchGrupo, setSearchGrupo] = useState("");
//     const [loading, setLoading] = useState(true)
//     useEffect(() => {
//         const actions = [
//             {
//                 uid: "novoForm",
//                 text: "Novo",
//                 iconName: "Add",
//                 sequence: "10",
//                 action: () => {
//                     navigate("/produto");
//                 },
//             },

//         ];

//         setActionsView(actions);

//         return () => {
//             setActionsView([]);
//         };
//     }, [navigate, setActionsView]);

//     useSetTitle("PRODUTOS");

//     const loadOptions = useCallback(async () => {
//         // // Carrega apenas uma vez.
//         // if (options.length === 0) {
//         let result = await fetchArray(Produto.getAll());

//         // console.log("result", result)

//         // console.log("p", result.map(p => p.nome))

//         result = result.map(p => {
//             // console.log("p", p)
//             if (p.nome) {
//                 p.nome = p.nome.toUpperCase()
//             }
//             // else {
//             //     console.log("x", p)
//             // }
//             if (p.grupo) {
//                 if (p.grupo.nome) {
//                     p.grupo.nome = p.grupo.nome.toUpperCase()
//                 }
//                 // else {
//                 //     console.log("x2", p)
//                 // }
//             }
//             // else {
//             //     console.log("x4", p)
//             // }
//             return p
//         })

//         setOptions(result);
//         // console.log("result2", result)
//         setFilteredOptions(result);
//         setLoading(false)
//         // }
//     }, []);

//     useEffect(() => {
//         loadOptions();
//     }, [loadOptions]);

//     const onChangeSearchNomeProduto = e => {
//         setSearchNomeProduto(e.target.value)
//     }

//     const onChangeSearchGrupo = e => {
//         setSearchGrupo(e.target.value)
//     }

//     const handleSearch = () => {
//         // console.log('handleSearch',options)
//         setFilteredOptions(
//             options.filter(produto => {

//                 // console.log('produto',produto)
//                 // console.log(searchNomeProduto)
//                 // console.log(produto.nome)
//                 let nome, grupoNome;
//                 if (produto.nome?.toUpperCase().includes(searchNomeProduto.toUpperCase())) {
//                     nome = true;
//                     // console.log("nome")
//                 }

//                 if (produto.grupo?.nome.toUpperCase().includes(searchGrupo.toUpperCase())) {
//                     grupoNome = true;
//                     // console.log("grupo")
//                 }

//                 return nome + grupoNome
//             })
//         )
//     }


//     return (
//         < Box sx={{ flex: 1, height: { xs: "100%", sm: "60vh" } }}>
//             {/* {console.log("options", options)} */}
//             <Box sx={{ textAlign: "center", mt: 0 }}>

//                 <Accordion sx={{ boxShadow: 3, mb: 1 }}>
//                     <AccordionSummary
//                         expandIcon={<ExpandMoreIcon />}
//                         aria-controls="panel1a-content"
//                         id="panel1a-header"
//                     >
//                         <Typography>FILTRO</Typography>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                         <TextField
//                             sx={{ width: "100%", my: 2 }}
//                             id="grupoSearchTextField"
//                             label="GRUPO"
//                             variant="standard"
//                             onChange={onChangeSearchGrupo}
//                             value={searchGrupo}
//                             onKeyUp={() => handleSearch()}
//                             inputProps={{ style: { textTransform: "uppercase" } }}
//                         />
//                         <TextField
//                             sx={{ width: "100%" }}
//                             id="nomeProdutoTextField"
//                             label="PRODUTO/SERVIÇO"
//                             variant="standard"
//                             onChange={onChangeSearchNomeProduto}
//                             value={searchNomeProduto}
//                             onKeyUp={() => handleSearch()}
//                             inputProps={{ style: { textTransform: "uppercase" } }}
//                         />
//                     </AccordionDetails>
//                 </Accordion>
//             </Box>

//             <DataTable
//                 columns={Produto.searchColumns}
//                 rows={filteredOptions}
//                 onRowClick={row => navigate("/produto?uid=" + row.id)}
//                 components={{
//                     LoadingOverlay: CircularProgress,
//                 }}
//                 loading={loading}
//                 sx={{
//                     "& .MuiDataGrid-row:hover": {
//                         cursor: "pointer",
//                     },
//                 }}
//             />
//         </Box >
//     )
// }